import React from "react";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import reactStringReplace from "react-string-replace";

import { GET_TERMS_AND_CONDITIONS } from "../../Graphql/queries/queryGetTermsAndConditions";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { useToastError } from "../../Hooks/useToastError";
import IconBack from "../../components/Icons/IconBack";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";

import { TextDescription, Title, Content, Modal, BackButton, ContainerBack, TextBack } from "./styles";

const ModalTermsDataPerson = ({ setModalVisible, modalVisible, idTermsAndConditions }) => {
  const { error, data, loading } = useQuery(GET_TERMS_AND_CONDITIONS, {
    variables: {
      getTermAndConditionsId: idTermsAndConditions,
    },
  });

  useToastError(error);

  function ReplaceText(content) {
    const bold = /\*\*(.*?)\*\*/gm;
    const urlExp = /\[\[(.*?)\[\[/gm;
    const texts = reactStringReplace(content, bold, (match, i) => <b key={i}>{match}</b>);
    return texts.map((text) => {
      if (typeof text === "string") {
        const TF = reactStringReplace(text, "$", (i) => (
          <div key={i}>
            <br />
          </div>
        ));
        return reactStringReplace(TF, urlExp, (match, i) => {
          const url = `https://${match}`;
          return (
            <a href={url} key={i}>
              {match}
            </a>
          );
        });
      } else {
        return text;
      }
    });
  }

  if (loading) {
    return <LoadingScreen />;
  }

  const getTerms = data?.getTermAndConditions;

  return modalVisible ? (
    <Modal onClick={() => setModalVisible(false)}>
      <Content onClick={(event) => event.stopPropagation()}>
        <BackButton onClick={() => setModalVisible(false)}>
          <ContainerBack>
            <IconBack />
            <TextBack>Atrás</TextBack>
          </ContainerBack>
        </BackButton>
        <Title>{getTerms?.title}</Title>
        <TextDescription>{ReplaceText(getTerms?.content)}</TextDescription>
        <PrimaryNormal title="Cerrar" onClick={() => setModalVisible(false)} />
      </Content>
    </Modal>
  ) : (
    <div />
  );
};

ModalTermsDataPerson.propTypes = {
  setModalVisible: PropTypes.func,
  modalVisible: PropTypes.bool,
  idTermsAndConditions: PropTypes.string,
};

export default ModalTermsDataPerson;
